<template lang="pug">
  .lei-status(:class="rootClass", @click="$emit('click')")
    font-awesome-icon.status-icon(:color="getColorByStatus(status)", icon="circle", :size="size")
    slot {{status}}
</template>
<script>
import { dangerColor, successColor, primaryColor, warningColor, dangerColorLight, } from '../../constants/colors'
export default {
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'lg',
    },
    status: {
      type: String,
      default: '',
    },
  },
  methods: {
    getColorByStatus (status) {
      const colorDefiner = {
        'ANNULLED': dangerColor,
        'DUPLICATE': primaryColor,
        'ACTIVE': successColor,
        'INACTIVE': warningColor,
        'ISSUED': successColor,
        'LAPSED': dangerColorLight,
        'MERGED': primaryColor,
        'PENDING_ARCHIVAL': primaryColor,
        'PENDING_TRANSFER': primaryColor,
        'RETIRED': primaryColor,
      }
      return colorDefiner[status] || primaryColor
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .lei-status
    display flex
    align-items center
    .status-icon
      font-size 125%
      margin-right 8px
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiStatus.vue